import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";

export const AdminProtectedRoute = ({ children, requireSuperAdmin = false, requireFranchise = false }) => {
  const { admin, ready } = useAdminAuth();
  const loc = useLocation();
  if (!ready)
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground bg-background">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  if (!admin) {
    const target = requireSuperAdmin ? "/superadmin/login" : "/admin/login";
    return <Navigate to={target} replace state={{ from: loc.pathname }} />;
  }
  if (requireSuperAdmin && admin.role !== "superadmin")
    return <Navigate to="/superadmin/login" replace />;
  // Franchise-scoped surface — accept franchise + franchise_staff.
  // Admin/Superadmin can also enter (for support) since their scope
  // is broader; the backend already collapses their view to "all
  // cities" when there's no assigned_city claim.
  if (requireFranchise && !["franchise", "franchise_staff", "admin", "superadmin"].includes(admin.role))
    return <Navigate to="/admin/login" replace />;
  if (!requireSuperAdmin && !requireFranchise
      && !["admin", "superadmin", "franchise", "franchise_staff"].includes(admin.role))
    return <Navigate to="/admin/login" replace />;
  return children;
};
